'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    display: -webkit-box;\n    margin-left: ', ';\n    margin-right: ', ';\n    width: calc(100% + ', ');\n    box-sizing: border-box;\n'], ['\n    display: flex;\n    display: -webkit-box;\n    margin-left: ', ';\n    margin-right: ', ';\n    width: calc(100% + ', ');\n    box-sizing: border-box;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-width: 40px;\n    height: 40px;\n'], ['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-width: 40px;\n    height: 40px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    flex-grow: 1;\n    height: 40px;\n    box-sizing: border-box;\n    width: 100%;\n'], ['\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    flex-grow: 1;\n    height: 40px;\n    box-sizing: border-box;\n    width: 100%;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    display: inline-flex;\n    flex: 1;\n    justify-content: ', ';\n    align-items: center;\n    height: 40px;\n    padding: 0 5px;\n    box-sizing: border-box;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n'], ['\n    display: inline-flex;\n    flex: 1;\n    justify-content: ', ';\n    align-items: center;\n    height: 40px;\n    padding: 0 5px;\n    box-sizing: border-box;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    font-family: \'Poppins\', sans-serif;\n    font-size: inherit;\n    ', ';\n    ', ';\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 100%;\n    padding: 0 2px;\n'], ['\n    font-family: \'Poppins\', sans-serif;\n    font-size: inherit;\n    ', ';\n    ', ';\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 100%;\n    padding: 0 2px;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-width: 40px;\n    height: 40px;\n    cursor: pointer;\n'], ['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-width: 40px;\n    height: 40px;\n    cursor: pointer;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _metrixCommon = require('metrix-common');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TableHeaderContainer = _styledComponents2.default.div(_templateObject, function (_ref) {
    var mobile = _ref.mobile,
        tablet = _ref.tablet,
        desktop = _ref.desktop;
    return mobile && '-10px' || tablet && '-40px' || desktop && '-40px';
}, function (_ref2) {
    var mobile = _ref2.mobile,
        tablet = _ref2.tablet,
        desktop = _ref2.desktop;
    return mobile && '-10px' || tablet && '-40px' || desktop && '-40px';
}, function (_ref3) {
    var mobile = _ref3.mobile,
        tablet = _ref3.tablet,
        desktop = _ref3.desktop;
    return mobile && '20px' || tablet && '80px' || desktop && '80px';
});

var HeaderIconContainer = _styledComponents2.default.div(_templateObject2);

var LocationIcon = function LocationIcon() {
    return _react2.default.createElement(
        'svg',
        { xmlns: 'http://www.w3.org/2000/svg',
            width: '20',
            height: '25',
            viewBox: '0 0 20 25'
        },
        _react2.default.createElement('path', { d: 'M6.24999 13.75H8.74999V10.313H11.25V13.751H13.75V7.81404L9.99999 5.31404L6.24999 7.81404V13.75ZM9.99999 21.687C12.1413 19.8096 14.0411 17.6736 15.656 15.328C16.7389 13.844 17.3783 12.0831 17.5 10.25C17.5372 9.22131 17.3637 8.19587 16.9902 7.23664C16.6167 6.27742 16.0511 5.40466 15.328 4.67201C14.6353 3.9653 13.8052 3.40799 12.8888 3.03443C11.9725 2.66088 10.9893 2.47899 9.99999 2.50001C9.01064 2.47899 8.02749 2.66088 7.11113 3.03443C6.19478 3.40799 5.36467 3.9653 4.67199 4.67201C3.94891 5.40466 3.38325 6.27742 3.00974 7.23664C2.63623 8.19587 2.46276 9.22131 2.49999 10.25C2.6217 12.0831 3.26113 13.844 4.34398 15.328C5.95884 17.6736 7.85871 19.8096 9.99999 21.687ZM9.99999 25C7.15505 22.6919 4.6278 20.0177 2.48398 17.047C0.996335 15.0788 0.131281 12.7107 -1.08872e-05 10.247C-0.0637891 8.85842 0.172627 7.47242 0.693104 6.18348C1.21358 4.89454 2.00589 3.73298 3.016 2.77803C4.89354 0.978087 7.3991 -0.0185573 9.99999 1.07265e-05C12.6013 -0.0177516 15.1069 0.979982 16.984 2.78102C17.9941 3.73597 18.7864 4.89753 19.3069 6.18647C19.8274 7.47541 20.0638 8.86142 20 10.25C19.8687 12.7137 19.0036 15.0818 17.516 17.05C15.372 20.0196 12.8447 22.6928 9.99999 25Z',
            fill: _metrixCommon.Colors.StrokeVeryDark
        })
    );
};

var OwnerIcon = function OwnerIcon() {
    return _react2.default.createElement(
        'svg',
        { xmlns: 'http://www.w3.org/2000/svg',
            width: '24',
            height: '24',
            viewBox: '0 0 24 24'
        },
        _react2.default.createElement('path', { d: 'M12 3.69231C9.45099 3.69231 7.38462 5.75869 7.38462 8.30769C7.38462 10.8567 9.45099 12.9231 12 12.9231C14.549 12.9231 16.6154 10.8567 16.6154 8.30769C16.6154 5.75869 14.549 3.69231 12 3.69231ZM9.23077 8.30769C9.23077 6.77829 10.4706 5.53846 12 5.53846C13.5294 5.53846 14.7692 6.77829 14.7692 8.30769C14.7692 9.8371 13.5294 11.0769 12 11.0769C10.4706 11.0769 9.23077 9.8371 9.23077 8.30769Z',
            fill: _metrixCommon.Colors.StrokeVeryDark
        }),
        _react2.default.createElement('path', { d: 'M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM12 1.84615C6.39219 1.84615 1.84615 6.39219 1.84615 12C1.84615 14.0216 2.43696 15.9053 3.45534 17.4877C6.1347 16.3097 9.03211 15.697 11.9659 15.6923C14.9225 15.6876 17.8441 16.3004 20.5446 17.4877C21.563 15.9053 22.1538 14.0216 22.1538 12C22.1538 6.39219 17.6078 1.84615 12 1.84615ZM12 22.1538C9.10147 22.1538 6.48661 20.9393 4.63653 18.9914C6.95924 18.0377 9.44936 17.5425 11.9689 17.5385C14.5092 17.5344 17.0212 18.0297 19.3634 18.9915C17.5134 20.9393 14.8985 22.1538 12 22.1538Z',
            fill: _metrixCommon.Colors.StrokeVeryDark
        })
    );
};

var ClaimIcon = function ClaimIcon() {
    return _react2.default.createElement(
        'svg',
        { xmlns: 'http://www.w3.org/2000/svg',
            width: '24',
            height: '24',
            viewBox: '0 0 24 24'
        },
        _react2.default.createElement('path', { d: 'M12 23.9998C10.3916 24.0102 8.79841 23.6885 7.3201 23.0548C5.89824 22.4505 4.60505 21.5798 3.51018 20.4898C2.42016 19.3949 1.54954 18.1018 0.945227 16.6799C0.311495 15.2016 -0.0102124 13.6084 0.000247095 12C-0.0102124 10.3916 0.311495 8.79841 0.945227 7.3201C1.54954 5.89824 2.42016 4.60505 3.51018 3.51018C4.60505 2.42017 5.89824 1.54955 7.3201 0.945235C8.7984 0.311503 10.3916 -0.0102124 12 0.00024709C13.6084 -0.0102124 15.2016 0.311503 16.6799 0.945235C18.1018 1.54955 19.395 2.42017 20.4898 3.51018C21.5798 4.60505 22.4505 5.89824 23.0548 7.3201C23.6885 8.79841 24.0102 10.3916 23.9998 12C24.0102 13.6084 23.6885 15.2016 23.0548 16.6799C22.4505 18.1018 21.5798 19.3949 20.4898 20.4898C19.395 21.5798 18.1018 22.4505 16.6799 23.0548C15.2016 23.6885 13.6084 24.0102 12 23.9998ZM8.52007 20.9398L9.96004 17.6399C9.13594 17.349 8.39117 16.8695 7.78509 16.2399C7.17204 15.6058 6.68807 14.8587 6.36012 14.0399L3.06018 15.4199C3.51065 16.6847 4.23842 17.8328 5.19014 18.7799C6.13341 19.7291 7.26878 20.4655 8.52007 20.9398ZM6.36012 9.96006C6.6875 9.13956 7.1715 8.39063 7.78509 7.75509C8.3917 7.12726 9.13642 6.64959 9.96004 6.3601L8.58007 3.06018C7.31728 3.52914 6.17104 4.26599 5.22014 5.22011C4.26602 6.17101 3.52914 7.3173 3.06018 8.58009L6.36012 9.96006ZM12 15.5999C12.4742 15.6083 12.9451 15.5196 13.3837 15.339C13.8223 15.1584 14.2192 14.8898 14.55 14.5499C14.8899 14.2192 15.1584 13.8223 15.339 13.3837C15.5196 12.9451 15.6084 12.4742 15.5999 12C15.6084 11.5258 15.5196 11.0549 15.339 10.6163C15.1584 10.1777 14.8899 9.78084 14.55 9.45006C14.2192 9.11016 13.8223 8.8416 13.3837 8.66102C12.9451 8.48043 12.4742 8.39166 12 8.4001C11.5258 8.39166 11.0549 8.48043 10.6163 8.66102C10.1777 8.8416 9.78083 9.11016 9.45005 9.45006C9.11015 9.78084 8.84162 10.1777 8.66103 10.6163C8.48045 11.0549 8.39164 11.5258 8.40008 12C8.39164 12.4742 8.48045 12.9451 8.66103 13.3837C8.84162 13.8223 9.11015 14.2192 9.45005 14.5499C9.78083 14.8898 10.1777 15.1584 10.6163 15.339C11.0549 15.5196 11.5258 15.6083 12 15.5999ZM15.4799 20.9398C16.7252 20.4693 17.8554 19.738 18.7949 18.7948C19.738 17.8554 20.4693 16.7252 20.9398 15.4799L17.6399 14.0399C17.3519 14.8607 16.8798 15.6047 16.2599 16.2149C15.6391 16.8255 14.9055 17.3094 14.1 17.6399L15.4799 20.9398ZM17.6399 9.90007L20.9398 8.52009C20.4693 7.27483 19.738 6.14457 18.7949 5.20516C17.8554 4.26201 16.7252 3.53066 15.4799 3.06018L14.1 6.4201C14.9034 6.70949 15.6314 7.176 16.2299 7.78506C16.8295 8.39445 17.308 9.1122 17.6399 9.90007Z',
            fill: _metrixCommon.Colors.StrokeVeryDark
        })
    );
};

var HeaderContentContainer = _styledComponents2.default.div(_templateObject3);

var HeaderContentFlex = _styledComponents2.default.div(_templateObject4, function (_ref4) {
    var align = _ref4.align;
    return align === 'left' ? 'flex-start' : 'flex-end';
});

var ItemLabel = _styledComponents2.default.p(_templateObject5, function (_ref5) {
    var italic = _ref5.italic;
    return italic ? 'font-style: italic' : null;
}, function (_ref6) {
    var bold = _ref6.bold;
    return bold ? 'font-weight: bold' : null;
});

var HeaderChevronContainer = _styledComponents2.default.div(_templateObject6);

var TableHeader = function TableHeader(_ref7) {
    var component = _ref7.component,
        isCollapsible = _ref7.isCollapsible,
        isCollapsed = _ref7.isCollapsed,
        expandHandler = _ref7.expandHandler,
        reference = _ref7.reference,
        mobile = _ref7.mobile,
        tablet = _ref7.tablet,
        desktop = _ref7.desktop,
        isErrors = _ref7.isErrors,
        props = _objectWithoutProperties(_ref7, ['component', 'isCollapsible', 'isCollapsed', 'expandHandler', 'reference', 'mobile', 'tablet', 'desktop', 'isErrors']);

    var tableHeaderDef = component.components.find(function (el) {
        return el.type === 'tableHeader';
    });

    var iconName = tableHeaderDef && tableHeaderDef.elements && tableHeaderDef.elements.find(function (el) {
        return el.code === 'Icon';
    }) && tableHeaderDef.elements.find(function (el) {
        return el.code === 'Icon';
    }).value;
    var Icon = void 0;
    switch (iconName) {
        case 'person':
            Icon = OwnerIcon;
            break;
        case 'claim':
            Icon = ClaimIcon;
            break;
        case 'location':
        default:
            Icon = LocationIcon;
    }

    var placeholderDef = tableHeaderDef && tableHeaderDef.elements && tableHeaderDef.elements.find(function (el) {
        return el.code === 'Placeholder';
    });
    var placeholder = {
        fontStyle: placeholderDef && placeholderDef.elements && placeholderDef.elements.find(function (el) {
            return el.code === 'FontStyle';
        }) && placeholderDef.elements.find(function (el) {
            return el.code === 'FontStyle';
        }).value,
        value: props.return && props.return.elements && props.return.elements.find(function (el) {
            return el.code === 'TableHeader';
        }) && props.return.elements.find(function (el) {
            return el.code === 'TableHeader';
        }).elements && props.return.elements.find(function (el) {
            return el.code === 'TableHeader';
        }).elements.find(function (el) {
            return el.code === 'FormattedAddress';
        }) && props.return.elements.find(function (el) {
            return el.code === 'TableHeader';
        }).elements.find(function (el) {
            return el.code === 'FormattedAddress';
        }).elements && props.return.elements.find(function (el) {
            return el.code === 'TableHeader';
        }).elements.find(function (el) {
            return el.code === 'FormattedAddress';
        }).elements.find(function (el) {
            return el.code === 'Value';
        }) && props.return.elements.find(function (el) {
            return el.code === 'TableHeader';
        }).elements.find(function (el) {
            return el.code === 'FormattedAddress';
        }).elements.find(function (el) {
            return el.code === 'Value';
        }).value,
        placeholder: placeholderDef && placeholderDef.value
    };

    var tableHeaderDefElements = placeholderDef && tableHeaderDef.elements && tableHeaderDef.elements.filter(function (el) {
        return el.code !== 'Icon' && el.code !== 'Placeholder' && el.code !== 'Rules';
    });

    var getValueFromReferences = function getValueFromReferences(path, value) {
        var pathComponents = path.split('.');

        var current = reference.references;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = pathComponents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _component = _step.value;

                current = current[_component];
                if (!current) {
                    return null;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        var item = current.find(function (item) {
            return item.code === value;
        });
        return item ? item.value : '';
    };

    var findValueElement = function findValueElement(elements, itemCode) {
        var item = elements.find(function (el) {
            return el.code === itemCode;
        }) || elements.find(function (el) {
            return el.code === 'Compound';
        }) && elements.find(function (el) {
            return el.code === 'Compound';
        }).elements.find(function (el) {
            return el.code === itemCode;
        });

        if (!item || !item.elements) return '';

        var valueElement = item.elements.find(function (el) {
            return el.code === 'Value';
        });
        var option = item.elements.find(function (el) {
            return el.code === 'Options';
        });

        // We check for the availability of an option to recognize DropDown
        if (!option && valueElement && valueElement.value) {
            return valueElement.value;
        } else if (option && option.value && valueElement && valueElement.value) {
            return getValueFromReferences(option.value, valueElement.value);
        }
        return '';
    };

    var getValue = function getValue(itemCode) {
        if (!props.return || !props.return.elements) return '';

        var staticValue = findValueElement(props.return.elements.find(function (el) {
            return el.code === 'TableHeader';
        }).elements, itemCode);
        var dynamicValue = findValueElement(props.return.elements.find(function (el) {
            return el.code === 'Columns';
        }).elements, itemCode);

        return dynamicValue || staticValue;
    };

    var tableHeaderItems = [];
    if (placeholder && placeholder.value) {
        tableHeaderItems.push(_react2.default.createElement(_metrixCommon.Label, { text: placeholder.value,
            bold: placeholder.fontStyle ? placeholder.fontStyle === 'bold' : false,
            italic: placeholder.fontStyle ? placeholder.fontStyle === 'italic' : false,
            textAlign: _metrixCommon.Alignments.left,
            size: _metrixCommon.Sizes.md
        }));
    } else if (tableHeaderDefElements && tableHeaderDefElements.length > 0) {
        tableHeaderDefElements.map(function (item, index) {
            var rules = item.elements.find(function (el) {
                return el.code === 'Rules';
            }) && item.elements.find(function (el) {
                return el.code === 'Rules';
            }).elements;

            var itemObject = {
                fontStyle: rules && rules.find(function (el) {
                    return el.code === 'FontStyle';
                }) && rules.find(function (el) {
                    return el.code === 'FontStyle';
                }).value,
                align: rules && rules.find(function (el) {
                    return el.code === 'Align';
                }) && rules.find(function (el) {
                    return el.code === 'Align';
                }).value,
                postfix: rules && rules.find(function (el) {
                    return el.code === 'Postfix';
                }) && rules.find(function (el) {
                    return el.code === 'Postfix';
                }).value || '',
                prefix: rules && rules.find(function (el) {
                    return el.code === 'Prefix';
                }) && rules.find(function (el) {
                    return el.code === 'Prefix';
                }).value || ''
            };

            if (item.code === 'Compound') {
                var compoundValue = '';
                item.elements.forEach(function (compItem) {
                    if (compItem.code !== 'Rules') {
                        compoundValue += getValue(compItem.code) + ' ';
                    }
                });
                itemObject.value = compoundValue;
            } else {
                itemObject.value = getValue(item.code);
            }

            itemObject.value && tableHeaderItems.push(index === 0 && itemObject.value.trim() === '' ? _react2.default.createElement(
                HeaderContentFlex,
                { key: index,
                    align: itemObject.align
                },
                _react2.default.createElement(_metrixCommon.Label, { text: placeholder.value || placeholder.placeholder,
                    bold: placeholder.fontStyle ? placeholder.fontStyle === 'bold' : false,
                    italic: placeholder.fontStyle ? placeholder.fontStyle === 'italic' : false,
                    textAlign: _metrixCommon.Alignments.left,
                    size: _metrixCommon.Sizes.md
                })
            ) : _react2.default.createElement(
                HeaderContentFlex,
                { key: index,
                    align: itemObject.align
                },
                _react2.default.createElement(
                    ItemLabel,
                    {
                        bold: itemObject.fontStyle ? itemObject.fontStyle === 'bold' : false,
                        italic: itemObject.fontStyle ? itemObject.fontStyle === 'italic' : false,
                        size: _metrixCommon.Sizes.md
                    },
                    itemObject.prefix + itemObject.value + itemObject.postfix
                )
            ));
        });
    } else {
        return null;
    }

    return _react2.default.createElement(
        TableHeaderContainer,
        { mobile: mobile,
            tablet: tablet,
            desktop: desktop
        },
        _react2.default.createElement(
            HeaderIconContainer,
            null,
            _react2.default.createElement(Icon, null)
        ),
        _react2.default.createElement(
            HeaderContentContainer,
            null,
            tableHeaderItems
        ),
        isCollapsible && !isErrors && _react2.default.createElement(
            HeaderChevronContainer,
            { onClick: expandHandler },
            _react2.default.createElement(_metrixCommon.ArrowIcon, { direction: isCollapsed ? 'down' : 'up',
                disabled: !isCollapsible
            })
        )
    );
};

exports.default = TableHeader;


TableHeader.propTypes = {
    component: _propTypes2.default.object.isRequired,
    return: _propTypes2.default.object.isRequired,
    isCollapsible: _propTypes2.default.bool.isRequired,
    isCollapsed: _propTypes2.default.bool.isRequired,
    expandHandler: _propTypes2.default.func.isRequired,
    reference: _propTypes2.default.object.isRequired,
    mobile: _propTypes2.default.bool.isRequired,
    tablet: _propTypes2.default.bool.isRequired,
    desktop: _propTypes2.default.bool.isRequired,
    isErrors: _propTypes2.default.bool.isRequired
};